<style lang="scss">
@import '../css/sub.scss';
</style>
<template>
  <div class="donga-audit">
  <audit-header></audit-header>
    <div class="audit-template sub-template">
      <div role="sub" class="audit-sub">
        <div id="sub-sections">
          <div class="visual-top report-second">
            <h2 class="page-tit">제보하기</h2>
            <p class="page-sub-tit pc-show">감사실과 제보자간의 쌍방향 소통방식으로 운영되며 동아쏘시오 그룹사 임직원 뿐만 아니라<br>고객, 협력회사 등 모든 이해관계자 여러분의 소중한 의견을 자유롭게 제안할 수 있는 곳으로 그룹사와 이해관계자<br>모두의 발전에 도움이 되도록 적극적인 참여 바랍니다.</p>
          </div>
          <div class="col-container pc-container">
            <div class="sub-contents">
              <div class="default-tab reporting-tab">
                <div class="tabs">
                  <button type="button" class="tab active">실명 제보</button>
                  <button type="button" class="tab" @click="selectReport()">익명 제보</button>
                </div>
              </div>
              <section class="sub-section">
                <form @submit.prevent="submit">
                  <div class="sub-column report-apply">
                    <h3 class="section-tit title">1. 제보 대상</h3>
                    <p class="apply-notice">실명제보는 정확한 사항을 빠르게 알기 위해 개인정보 (이름, 이메일, 전화번호)를 필요로 합니다.</p>
                    <div class="required-item">
                      <span class="item-txt">표시된 항목은 필수 항목입니다.</span>
                    </div>
                    <div class="form-group-container">
                      <div class="form-group" :class="{ 'form-group-error': $v.targetCompany.$error }">
                        <div class="input-area">
                          <label class="form-label" for="target-company">제보대상회사</label>
                          <select class="default-select form-select"
                          v-model.trim="$v.targetCompany.$model"
                          id="target-company" @change="onChange()">
                            <option v-for="(company) in this.getReportCompanyList" v-bind:key="company.code"
                             v-bind:value="{value: company.code, text: company.title, isAlerted:company.isAlerted}">
                              {{ company.title }}
                            </option>
                          </select>
                        </div>
                        <modal v-if="showModal" @close="showModal=false">
                            <h3 slot="body">해당 제보는
                              <span v-if="this.targetCompany.text === '참메드'"> 동아ST</span>
                              <span v-else> {{this.targetCompany.text}}</span> 감사팀에서 조사를 진행합니다. <br>만일 동아제약-그룹감사팀의 조사를 원하시면 제보대상회사에서 '동아제약-그룹감사팀'으로 선택하여 주시기 바랍니다.</h3>
                            <button slot="footer" type="button" class="modal-button" @click="showModal=false">
                                확인
                            </button>
                          </modal>
                        <p class="error" v-if="!$v.targetCompany.required">제보대상 회사를 선택해주세요.</p>
                      </div>
                      <div class="form-group" :class="{ 'form-group-error': $v.targetType.$error }">
                        <div class="input-area">
                          <label class="form-label" for="target-type">유형</label>
                          <report-type-select
                            class="default-select form-select"
                            id="target-type"
                            v-model="$v.targetType.$model"
                            :options="filteredReportTypes"
                            :desc-map="typeDesc" />
                        </div>
                        <p class="error" v-if="!$v.targetType.required">유형을 선택해주세요.</p>
                      </div>
                      <div class="form-group" :class="{ 'form-group-error': $v.userName.$error }">
                        <div class="input-area">
                          <label class="form-label" for="user-name">이름</label>
                          <input
                            class="default-input form-input"
                            type="text"
                            v-model.trim="$v.userName.$model"
                            id="user-name"
                            placeholder="이름">
                        </div>
                        <p class="error" v-if="!$v.userName.required">이름을 입력해주세요.</p>
                      </div>
                      <div class="form-group" :class="{ 'form-group-error': $v.userEmail.$error }">
                        <div class="input-area">
                          <label class="form-label" for="user-email">이메일</label>
                          <input
                            class="default-input form-input"
                            type="text"
                            v-model.trim="$v.userEmail.$model"
                            id="user-email"
                            placeholder="이메일">
                        </div>
                        <p class="error" v-if="!$v.userEmail.required">이메일을 입력해주세요.</p>
                        <p class="error" v-if="!$v.userEmail.email">이메일 양식에 맞게 작성해주세요.</p>
                      </div>
                      <div class="form-group" :class="{ 'form-group-error': $v.userTel.$error }">
                        <div class="input-area">
                          <label class="form-label" for="user-tel">전화번호</label>
                          <input
                            class="default-input form-input"
                            type="text"
                            v-model.trim="$v.userTel.$model"
                            id="user-tel"
                            placeholder="전화번호">
                        </div>
                        <p class="error" v-if="!$v.userTel.required">전화번호를 입력해주세요.</p>
                        <p class="error" v-if="!$v.userTel.phonePatten">전화번호 예시에 맞게 입력해주세요. * 하이픈(-) 포함</p>
                        <p class="example-txt">(예시: 010-1234-5678)</p>
                      </div>
                    </div>
                  </div>
                  <div class="sub-column report-apply second">
                    <h3 class="section-tit title">2.제보 내용</h3>
                    <p class="apply-notice">해당 사안에 대해서는 빠른 파악을 위해 가급적 구체적인 제보내용을 필요로 합니다. 다소 번거로우시겠지만 아래 조건에 기초하여 작성해주시면 최대한 빠르고 정확하게 처리하겠습니다.</p>
                    <div class="example-item">
                      <button type="button" class="example-btn" @click="exampleOpen()">작성예시</button>
                    </div>
                    <div class="required-item">
                      <span class="item-txt">표시된 항목은 필수 항목입니다.</span>
                    </div>
                    <div class="form-group-container">
                      <div class="form-group" :class="{ 'form-group-error': $v.reportTitle.$error }">
                        <div class="input-area">
                          <label class="form-label" for="report-title">제목</label>
                          <input
                            class="default-input form-input"
                            type="text"
                            v-model.trim="$v.reportTitle.$model"
                            id="report-title"
                            placeholder="제목">
                        </div>
                        <p class="error" v-if="!$v.reportTitle.required">필수 항목을 입력해주세요.</p>
                      </div>
                      <div class="form-group" :class="{ 'form-group-error': $v.reportWho.$error }">
                        <div class="input-area">
                          <label class="form-label" for="report-who">제보대상회사</label>
                          <input
                            class="default-input form-input"
                            type="text"
                            v-model.trim="$v.reportWho.$model"
                            id="report-who"
                            placeholder="제보대상회사">
                        </div>
                        <p class="error" v-if="!$v.reportWho.required">필수 항목을 입력해주세요.</p>
                      </div>
                      <div class="form-group" :class="{ 'form-group-error': $v.reportWhen.$error }">
                        <div class="input-area">
                          <label class="form-label" for="report-when">내용(서술형)</label>
                          <textarea
                            class="default-input form-textarea double"
                            type="text"
                            v-model.trim="$v.reportWhen.$model"
                            id="report-when"
                            placeholder="- 대상자 인적사항은 최대한 실명으로 작성
- 언제, 어디서, 무엇을 했는지 자세히 기술
- 사진, 문서 등 증빙이 첨부파일로 제출"></textarea>
                        </div>
                        <p class="error" v-if="!$v.reportWhen.required">필수 항목을 입력해주세요.</p>
                      </div>
                      <div class="form-group check-group" :class="{ 'form-group-error': $v.reportWhere.$error }">
                        <div class="input-area">
                          <span class="form-label">인지경로</span>
                          <div class="form-checkbox">
                            <div class="checkbox-area" v-for="(item, idx) in reportWhereOptions" :key="idx">
                              <input type="checkbox"
                                class="default-checkbox"
                                :id="'report-where-' + idx"
                                :value="item"
                                v-model="$v.reportWhere.$model">
                              <label :for="'report-where-' + idx" class="default-checkbox-label">{{ item }}</label>
                            </div>
                          </div>
                        </div>
                        <p class="error" v-if="!$v.reportWhere.required">인지경로를 하나 이상 선택해주세요.</p>
                      </div>
                      <div class="form-group radio-group" :class="{ 'form-group-error': $v.reportWhat.$error }">
                        <div class="input-area">
                          <span class="form-label">지속기간</span>
                          <div class="form-radio">
                            <div class="radio-area" v-for="(item, idx) in reportWhatOptions" :key="idx">
                              <input
                                type="radio"
                                class="default-radio"
                                :id="'report-what-' + idx"
                                name="report-what"
                                :value="item"
                                v-model="$v.reportWhat.$model">
                              <label :for="'report-what-' + idx" class="default-radio-label">{{ item }}</label>
                            </div>
                          </div>
                        </div>
                        <p class="error" v-if="!$v.reportWhat.required">지속기간을 선택해주세요.</p>
                      </div>
                      <div class="form-group" :class="{ 'form-group-error': $v.reportHow.$error }">
                        <div class="input-area">
                          <label class="form-label" for="report-how">면담자</label>
                          <input
                            class="default-input form-input"
                            type="text"
                            v-model.trim="$v.reportHow.$model"
                            id="report-how"
                            placeholder="이 문제를 알거나, 알 것으로 예상되는 사람은 누구인가요?">
                        </div>
                        <p class="error" v-if="!$v.reportHow.required">필수 항목을 입력해주세요.</p>
                      </div>
                      <div class="form-group" :class="{ 'form-group-error': $v.reportWhy.$error }">
                        <div class="input-area">
                          <label class="form-label" for="report-why">확인방법</label>
                          <input
                            class="default-input form-input"
                            type="text"
                            v-model.trim="$v.reportWhy.$model"
                            id="report-why"
                            placeholder="이 문제를 조사하기 위해서 가장 좋은 방법은 어떤 것이 있나요? Ex) 회계내역 검토, cctv확인, 이메일 로그 확인 등">
                        </div>
                        <p class="error" v-if="!$v.reportWhy.required">필수 항목을 입력해주세요.</p>
                      </div>
                      <div class="form-group radio-group">
                        <div class="input-area">
                          <span class="form-label">기타<span class="label-subInfo">(귀하는 대상회사와 어떠한 관계인가요?)</span></span>
                          <div class="form-radio">
                            <div class="radio-area" v-for="(item, idx) in reportEtcOptions" :key="idx">
                              <input
                                type="radio"
                                class="default-radio"
                                :id="'report-Etc-' + idx"
                                name="report-Etc"
                                :value="item"
                                v-model.trim="reportEtc">
                                <label :for="'report-Etc-' + idx" class="default-radio-label">{{ item }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="input-area">
                          <label class="form-label" for="report-file-input">첨부파일</label>
                          <div class="input-file-box">
                            <input type="text" id="report-file-input" class="default-input form-input" disabled v-model="fileRoute">
                            <label for="report-file" class="file-upload-btn">파일선택</label>
                            <button type="button" class="file-delete" @click="deleteFile()" v-if="!fileEmpty">X</button>
                          </div>
                          <input
                            class="blind"
                            type="file"
                            id="report-file"
                            name="file"
                            @change="fileSelect"
                            ref="uploadFile">
                        </div>
                        <p class="example-txt">10MB 이하만 가능합니다.</p>
                      </div>
                    </div>
                  </div>
                  <div class="sub-column report-apply third">
                    <h3 class="section-tit title">3.제보접수 확인</h3>
                    <div class="required-item">
                      <span class="item-txt">표시된 항목은 필수 항목입니다.</span>
                    </div>
                    <div class="form-group-container">
                      <!-- <div class="form-group">
                        <div class="input-area">
                          <span class="form-label" for="user-password">제보결과 회신(확인) 방법</span>
                          <div class="form-radio">
                            <div class="radio-area">
                              <input type="radio" class="default-radio" id="report-result-first" name="report-result" v-model="descChk" @change="descClick" value="홈페이지 확인">
                              <label for="report-result-first" class="default-radio-label">홈페이지 확인(제보접수번호/비밀번호)</label>
                            </div>
                            <div class="radio-area">
                              <input type="radio" class="default-radio" id="report-result-second" name="report-result" v-model="descChk" @change="descClick" value="이메일">
                              <label for="report-result-second" class="default-radio-label">이메일</label>
                              <p class="result-notice">이메일로만 접수 시 중간진행단계의 감사실 코멘트를 볼 수 없습니다.</p>
                            </div>
                          </div>
                        </div>
                      </div> -->
                      <div class="form-group" :class="{ 'form-group-error': $v.password.$error }">
                          <div class="input-area">
                            <label class="form-label" for="user-password">비밀번호</label>
                            <input
                              class="default-input form-input"
                              v-model.trim="$v.password.$model"
                              type="password"
                              id="user-password"
                              placeholder="비밀번호">
                          </div>
                          <p class="error" v-if="!$v.password.required">패스워드를 입력해주세요.</p>
                          <p class="error" v-if="!$v.password.pwPattern">패스워드는 8-16자리 영문, 숫자, 특수문자 조합으로 해주세요.</p>
                      </div>
                      <p class="result-notice">제보접수번호 및 비밀번호 분실에 대한 재확인 절차를 제공하지 않으니, <span class="txt-underline">제보자는 반드시 제보접수 번호를 보관하시기 바랍니다.</span><br>제보 시 희망하신 회신방법(전화 or 이메일)으로는 제보 처리 단계에서 담당자가 별도로 연락드립니다.</p>
                    </div>
                  </div>
                  <div class="report-submit-btns">
                      <button class="default-btn preview-btn" @click="popupOpen" type="button">미리보기</button>
                      <button class="default-btn next-btn" type="submit">접수</button>
                  </div>
                </form>
                <div class="pop-area" v-if="popupShow" id="popup-container">
                  <div class="popup">
                    <div class="pop-header">
                      <h3 class="tit">제보하기 미리보기</h3>
                      <button type="button" class="close" @click="popupClose">닫기</button>
                    </div>
                    <div class="desc-area">
                      <h4 class="desc-tit">제보 대상</h4>
                      <button type="button" @click="popupPrint" class="print-btn pc-show">Print</button>
                      <div class="column-container">
                        <div class="desc-column">
                          <span class="tit">제보대상회사</span>
                          <div class="desc">
                            {{targetCompany.text}}
                          </div>
                        </div>
                        <div class="desc-column">
                          <span class="tit">제보유형</span>
                          <div class="desc">
                            {{targetType.text}}
                          </div>
                        </div>
                      </div>
                      <div class="column-container">
                        <!-- <div class="desc-column">
                          <span class="tit">제보확인방법</span>
                          <div class="desc">
                            {{descChk}}
                          </div>
                        </div> -->
                        <div class="desc-column" style="width: 100%">
                          <span class="tit">익명실명 여부</span>
                          <div class="desc">
                            실명
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="desc-area">
                      <h4 class="desc-tit">제보 내용</h4>
                      <div class="desc-column">
                        <span class="tit">제보 제목</span>
                        <div class="desc">
                          {{reportTitle}}
                        </div>
                      </div>
                      <div class="desc-column">
                        <span class="tit">제보일</span>
                        <div class="desc">
                          {{ today }}
                        </div>
                      </div>
                      <div class="desc-column">
                        <span class="tit">제보 내용</span>
                        <div class="desc-container">
                          <div class="desc" style="float:none;overflow:auto">
                              <p class="content"><br>[제보대상회사]<br></p><span class="txt" v-html="reportWho.split('\n').join('<br>')"></span>
                              <p class="content"><br>[내용(서술형)]<br></p><span class="txt" v-html="reportWhen.split('\n').join('<br>')"></span>
                              <p class="content"><br>[인지경로]<br></p><span class="txt">{{ reportWhere.join(', ') }}</span>
                              <p class="content"><br>[지속기간]<br></p><span class="txt" v-html="reportWhat"></span>
                              <p class="content"><br>[면담자]<br></p><span class="txt" v-html="reportHow.split('\n').join('<br>')"></span>
                              <p class="content"><br>[확인방법]<br></p><span class="txt" v-html="reportWhy.split('\n').join('<br>')"></span>
                              <p class="content"><br>[기타]<br></p><span class="txt" v-html="reportEtc"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="chk-btn-area">
                      <button type="button" class="default-btn chk-btn" @click="popupClose">확인</button>
                    </div>
                  </div>
                  <div id="print-report" v-show="printShow" style="position: relative; overflow: hidden;width:1200px;margin:30px auto;">
                    <div class="pop-header" style="position: relative;text-align: center;">
                      <h3 class="tit" style="font-size: 40px;margin-bottom:0">제보하기</h3>
                    </div>
                    <div class="desc-area" style="position: relative;padding-top: 40px;">
                      <h4 class="desc-tit" style="font-size:22px;padding:10px 0; border-bottom:2px solid #000;margin-bottom:10px;">제보 대상</h4>
                      <div class="column-container" style="overflow:hidden;">
                        <div class="desc-column" style="float: left; width: 50%; padding:15px 0;text-align:left;border-bottom:1px solid #ccc;">
                          <span class="tit" style="float: left; width: 152px;display: block; color: #808080;font-weight: bold;font-size: 15px;">제보대상회사</span>
                          <div class="desc" style="float: left; padding-top: 0;color: #000;font-weight: bold;font-size: 14px;">
                            {{targetCompany.text}}
                          </div>
                        </div>
                        <div class="desc-column" style="float: left; width: 50%; padding:15px 0;text-align:left;border-bottom:1px solid #ccc;">
                          <span class="tit" style="float: left; width: 152px;display: block; color: #808080;font-weight: bold;font-size: 15px;">제보유형</span>
                          <div class="desc" style="float: left; padding-top: 0;color: #000;font-weight: bold;font-size: 14px;">
                            {{targetType.text}}
                          </div>
                        </div>
                      </div>
                      <div class="column-container" style="overflow:hidden;">
                        <!-- <div class="desc-column" style="float: left; width: 50%; padding:15px 0;text-align:left;border-bottom:1px solid #ccc;">
                          <span class="tit" style="float: left; width: 152px;display: block; color: #808080;font-weight: bold;font-size: 15px;">제보확인방법</span>
                          <div class="desc" style="float: left; padding-top: 0;color: #000;font-weight: bold;font-size: 14px;">
                            {{descChk}}
                          </div>
                        </div> -->
                        <div class="desc-column" style="float: left; width: 100%; padding:15px 0;text-align:left;border-bottom:1px solid #ccc;">
                          <span class="tit" style="float: left; width: 152px;display: block; color: #808080;font-weight: bold;font-size: 15px;">익명실명 여부</span>
                          <div class="desc" style="float: left; padding-top: 0;color: #000;font-weight: bold;font-size: 14px;">
                            실명
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="desc-area" style="position: relative;padding-top: 40px;">
                      <h4 class="desc-tit" style="font-size:22px;padding:10px 0; border-bottom:2px solid #000;margin-bottom:10px">제보 내용</h4>
                      <div class="desc-column" style="float: left; width: 50%; padding:15px 0;text-align:left;border-bottom:1px solid #ccc;">
                        <span class="tit" style="float: left; width: 152px;display: block; color: #808080;font-weight: bold;font-size: 15px;">제보 제목</span>
                        <div class="desc" style="float: left; padding-top: 0;color: #000;font-weight: bold;font-size: 14px;">
                          {{reportTitle}}
                        </div>
                      </div>
                      <div class="desc-column" style="float: left; width: 50%; padding:15px 0;text-align:left;border-bottom:1px solid #ccc;">
                        <span class="tit" style="float: left; width: 152px;display: block; color: #808080;font-weight: bold;font-size: 15px;">제보일</span>
                        <div class="desc" style="float: left; padding-top: 0;color: #000;font-weight: bold;font-size: 14px;">
                          {{ today }}
                        </div>
                      </div>
                      <div class="desc-column" style="clear:both; width: 100%; padding:15px 0;text-align:left;border-bottom:1px solid #ccc;">
                        <span class="tit" style="width: 100%;display: block; color: #808080;font-weight: bold;font-size: 15px;">제보 내용</span>
                      </div>
                      <div class="desc-container">
                        <div class="desc" style="float:none;overflow:auto">
                            <p class="content"><br>[제보대상회사]<br></p><span class="txt" style="word-break:break-all" v-html="reportWho.split('\n').join('<br>')"></span>
                            <p class="content"><br>[내용(서술형)]<br></p><span class="txt" style="word-break:break-all" v-html="reportWhen.split('\n').join('<br>')"></span>
                            <p class="content"><br>[인지경로]<br></p><span class="txt" style="word-break:break-all" v-html="reportWhere.join(', ')"></span>
                            <p class="content"><br>[지속기간]<br></p><span class="txt" style="word-break:break-all" v-html="reportWhat"></span>
                            <p class="content"><br>[면담자]<br></p><span class="txt" style="word-break:break-all" v-html="reportHow.split('\n').join('<br>')"></span>
                            <p class="content"><br>[확인방법]<br></p><span class="txt" style="word-break:break-all" v-html="reportWhy.split('\n').join('<br>')"></span>
                            <p class="content"><br>[기타]<br></p><span class="txt" style="word-break:break-all" v-html="reportEtc"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <example-popup :exampleVisible.sync="exampleVisible"></example-popup>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <audit-footer></audit-footer>
  </div>
</template>
<script>
import AuditHeader from '@/components/AuditHeader'
import AuditFooter from '@/components/AuditFooter'
import ExampleWriting from '@/components/ExampleWriting'
import Modal from '@/components/Modal'
import { required, minLength, email, helpers } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue'
import VueHtmlToPaper from 'vue-html-to-paper'
import ReportTypeSelect from '@/components/ReportTypeSelect'
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ]
}
Vue.use(VueHtmlToPaper, options)
const pwPattern = helpers.regex('alpha', /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,16}$/)
const phonePatten = helpers.regex('alpha', /^\d{2,3}-\d{3,4}-\d{4}$/)
const body = document.getElementsByTagName('body')[0]
const REPORT_TYPE_DESC = {
  CHEAT: '1)금품/향응 수수\n2)청탁 및 부당한 요구\n3)절도/사기, 공금횡령 등 유용\n4)회사정보 유출\n5)문서 조작 및 부정보고\n6)직권남용(협력업체에 대한 갑질)\n7)기타 윤리규정 위반 등',
  INDISCIPLINE: '1)근태불량(사적행위, 허위근태 등)\n2)성희롱, 성폭력 등의 성비위\n3)직장내 괴롭힘 및 갑질 행위\n4)직원간 금전거래\n5)기타 법령 및 주요사규 위반',
  ABSURDITY: '1)공정거래관련 법령 위반행위\n2)기타 CP위반 행위',
  ETC: '1)사회적 가치 저해(ESG, 인권침해 등)\n2)업무/제도 개선 건의\n3)기타 부적절한 업무처리'
}
const REPORT_WHERE_OPTIONS = [
  '직접 목격',
  '직접 경험(피해 당사자)',
  '동료/지인을 통해 전해 들음',
  '문서/자료를 통해 확인',
  '언론/SNS 등 외부 매체',
  '기타'
]
const REPORT_WHAT_OPTIONS = [
  '1회',
  '1주일',
  '1주일~1개월',
  '1개월~3개월',
  '3개월~1년',
  '1년 이상'
]
const REPORT_ETC_OPTIONS = [
  '회사 구성원',
  '그룹 구성원',
  '협력사 임직원',
  '일반대중',
  '밝히고 싶지 않음',
  '기타'
]
export default {
  created () {
    this.setInit()
  },
  name: 'ReportSecond',
  components: {
    'audit-header': AuditHeader,
    'audit-footer': AuditFooter,
    'example-popup': ExampleWriting,
    'modal': Modal,
    'report-type-select': ReportTypeSelect
  },
  data () {
    return {
      showModal: false,
      exampleVisible: false,
      today: '',
      targetCompany: {},
      targetType: {},
      userName: '',
      userEmail: '',
      userTel: '',
      reportTitle: '',
      reportWho: '',
      reportWhen: '',
      reportWhere: [],
      reportWhereOptions: REPORT_WHERE_OPTIONS,
      reportWhat: '',
      reportWhatOptions: REPORT_WHAT_OPTIONS,
      reportHow: '',
      reportWhy: '',
      reportEtc: '',
      reportEtcOptions: REPORT_ETC_OPTIONS,
      password: '',
      fileRoute: '선택된 파일 없음',
      output: null,
      popupShow: false,
      uploadFile: '',
      fileEmpty: true,
      printShow: false,
      typeDesc: REPORT_TYPE_DESC
    }
  },
  validations: {
    targetCompany: {
      required
    },
    targetType: {
      required
    },
    userName: {
      required
    },
    userTel: {
      required,
      phonePatten
    },
    userEmail: {
      required,
      minLength: minLength(4),
      email
    },
    password: {
      required,
      pwPattern
    },
    reportTitle: {
      required
    },
    reportWho: {
      required
    },
    reportWhen: {
      required
    },
    reportWhere: {
      required
    },
    reportWhat: {
      required
    },
    reportHow: {
      required
    },
    reportWhy: {
      required
    }
  },
  methods: {
    onChange () {
      if (this.targetCompany.isAlerted) {
        this.showModal = true
      }
    },
    exampleOpen () {
      this.exampleVisible = !this.exampleVisible
    },
    fileSelect (event) {
      console.log(this.$refs.uploadFile.files[0])
      if (this.$refs.uploadFile.files[0].size > 10 * 1024 * 1024) {
        alert('10MB 이하의 파일만 가능합니다.')
      } else {
        this.fileRoute = event.target.files[0].name
        this.fileEmpty = false
        this.uploadFile = this.$refs.uploadFile.files[0]
      }
    },
    popupOpen () {
      const date = new Date()
      let yy = date.getFullYear()
      let mm = date.getMonth() + 1
      let dd = date.getDate()
      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      this.today = yy + '-' + mm + '-' + dd
      body.classList.add('overflow')
      this.popupShow = true
    },
    popupClose () {
      body.classList.remove('overflow')
      this.popupShow = false
    },
    popupPrint () {
      this.$htmlToPaper('print-report')
    },
    deleteFile () {
      if (confirm('첨부파일을 삭제하시겠습니까?')) {
        this.uploadFile = ''
        this.fileRoute = '선택된 파일 없음'
        this.fileEmpty = true
      }
    },
    selectReport () {
      if (confirm('익명 제보를 하시겠습니까?')) {
        this.$router.push('/reportsecond02')
      }
    },
    submit () {
      const formData = new FormData()
      formData.append('companyType', this.targetCompany.value)
      formData.append('content',
        '<strong style=\'font-size:12px;\'>[제보대상회사]</strong><br><br>' + this.reportWho.split('\n').join('<br>') + '<br><br>' +
        '<strong style=\'font-size:12px;\'>[내용(서술형)]</strong><br><br>' + this.reportWhen.split('\n').join('<br>') + '<br><br>' +
        '<strong style=\'font-size:12px;\'>[인지경로]</strong><br><br>' + this.reportWhere.join(', ') + '<br><br>' +
        '<strong style=\'font-size:12px;\'>[지속기간]</strong><br><br>' + this.reportWhat + '<br><br>' +
        '<strong style=\'font-size:12px;\'>[면담자]</strong><br><br>' + this.reportHow.split('\n').join('<br>') + '<br><br>' +
        '<strong style=\'font-size:12px;\'>[확인방법]</strong><br><br>' + this.reportWhy.split('\n').join('<br>') + '<br><br>' +
        '<strong style=\'font-size:12px;\'>[기타]</strong><br><br>' + this.reportEtc)
      formData.append('email', this.userEmail)
      if (!this.fileEmpty) {
        formData.append('files', this.uploadFile)
      }
      formData.append('name', this.userName)
      formData.append('password', this.password)
      formData.append('phoneNumber', this.userTel)
      formData.append('postType', 'PUBLIC')
      formData.append('reportType', this.targetType.value)
      formData.append('title', this.reportTitle)
      this.$v.$touch()
      if (this.$v.$invalid) {
        alert('필수항목을 입력해주세요.')
      } else {
        if (confirm('접수 하시겠습니까?')) {
          this.$store.dispatch('apiInformantPosts', formData)
        }
      }
    },
    ...mapActions({
      setInit: 'apiReportCompanyAndTypeList'
    })
  },
  computed: {
    ...mapGetters(['getReportCompanyList', 'getReportTypeList']),
    filteredReportTypes () {
      const labels = {
        CHEAT: '부정비리',
        INDISCIPLINE: '근무기강',
        ABSURDITY: '공정거래',
        ETC: '기타사항'
      }
      return Object.keys(labels)
        .filter(code => this.getReportTypeList.some(t => t.code === code))
        .map(code => ({ code, title: labels[code] }))
    }
  }
}

</script>

<style scoped>
.modal-button {
  font-size: 18px;
  width: 100%;
}
.form-checkbox, .form-radio {
  display: flex;
  height: 38px;
  align-items: center;
  flex-wrap: wrap;
}
.form-checkbox .checkbox-area {
  display: flex;
  align-items: center;
}
.form-checkbox .checkbox-area .default-checkbox {
  width: 24px;
  height: 24px;
  margin-right: 5px;
}
.form-checkbox .checkbox-area, .form-radio .radio-area{
  margin-right: 10px;
}
label {margin-bottom: 0px; font-weight: 400; color: #000000;}
input[type=checkbox], input[type=radio] {margin:0px;}
.form-radio .radio-area {
  display: flex;
  align-items: center;
}
.form-radio .radio-area input[type=radio] {width: 13px; height: 13px; margin-right: 5px;}
.form-checkbox .checkbox-area {margin-top: 5px;}
.form-checkbox .checkbox-area input[type=checkbox] {width: 13px; height: 13px;}
.form-group .form-radio .radio-area:first-child {padding: 0; margin: 0; margin-right: 10px;}
.form-group .default-radio-label {
  font-size: 100%;
  color: #000000;
  font-weight: normal;
}
.form-group .form-textarea.double {height: 250px;}
.form-group .form-label {position: relative;}
.form-group .form-label .label-subInfo {position: absolute; top: 20px; left: 0; font-size: 12px;}
@media (max-width: 768px) {
  .form-group.check-group {height: 180px;}
  .form-group.check-group .error {padding-top: 5px;}
  .form-group.radio-group {height: 140px; margin-bottom: 25px;}
  .form-group.check-group .input-area, .form-group.radio-group .input-area {height: 100%;}
  .form-group .form-radio .radio-area:first-child {padding: 0; margin: 0; padding-top: 10px; margin-right: 10px;}
  .form-group .radio-area {padding-top: 10px;}
  .form-group .form-label .label-subInfo {position: absolute; top: 2px; left: 50px;}
}
</style>



// WEBPACK FOOTER //
// src/pages/ReportSecond.vue